/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, interest: NonNullable<unknown>, penalty: NonNullable<unknown>, correction: NonNullable<unknown> }} Case_Payment_Policy_Interest_BearingInputs */

const en_case_payment_policy_interest_bearing = /** @type {(inputs: Case_Payment_Policy_Interest_BearingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Interest-bearing: up to ${i?.count} installments; ${i?.interest}% monthly interest, ${i?.penalty}% penalty, and ${i?.correction}% monetary correction.`)
};

const pt_br2_case_payment_policy_interest_bearing = /** @type {(inputs: Case_Payment_Policy_Interest_BearingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Com juros: até ${i?.count} parcelas; juros de ${i?.interest}% ao mês, multa de ${i?.penalty}% e correção monetária de ${i?.correction}%.`)
};

/**
* | output |
* | --- |
* | "Interest-bearing: up to {count} installments; {interest}% monthly interest, {penalty}% penalty, and {correction}% monetary correction." |
*
* @param {Case_Payment_Policy_Interest_BearingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_policy_interest_bearing = /** @type {((inputs: Case_Payment_Policy_Interest_BearingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Policy_Interest_BearingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_policy_interest_bearing(inputs)
	return pt_br2_case_payment_policy_interest_bearing(inputs)
});